var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "sizes" },
      [
        _c("h1", [_vm._v(_vm._s(_vm.pageTitle))]),
        _c("div", { domProps: { innerHTML: _vm._s(_vm.PAGE_CONTENT) } }),
        _c("h2", [_vm._v("Как произвести замеры?")]),
        _c("div", { staticClass: "sizes-guide" }, [
          _c("ol", [
            _c("li", [
              _c("span", [_vm._v("Рост")]),
              _c("p", [
                _vm._v(
                  "Измеряется от пола до макушки головы. Важно стоять прямо, без напряжения, не сутулясь и не сгибая ноги в коленях."
                )
              ])
            ]),
            _c("li", [
              _c("span", [_vm._v("Длина шагового шва")]),
              _c("p", [
                _vm._v(
                  "Для джинсов и, иногда, для брюк, используется показатель «длина шагового шва», который  измеряется в дюймах и обозначает длину изделия по внутренней стороне ноги (от паха до пола). "
                )
              ])
            ]),
            _c("li", [
              _c("span", [_vm._v("Обхват шеи")]),
              _c("p", [
                _vm._v(
                  "Измеряется окружность шеи по тому месту, где обычно застегивается воротник"
                )
              ])
            ]),
            _c("li", [
              _c("span", [_vm._v("Обхват груди")]),
              _c("p", [
                _vm._v(
                  "Измеряется по самому широкому месту груди. Чтобы обеспечить удобную посадку,  не тяните измерительную ленту слишком сильно, сантиметр должен плотно, но без натяжки прилегать к телу. Рекомендуется снимать мерки в белье, с которым планируется носить изделие."
                )
              ])
            ]),
            _c("li", [
              _c("span", [_vm._v("Обхват талии")]),
              _c("p", [
                _vm._v(
                  "Измеряется по самому узкому месту талии. Чтобы обеспечить удобную посадку,  не тяните измерительную ленту слишком сильно, сантиметр должен плотно, но без натяжки прилегать к телу."
                )
              ])
            ]),
            _c("li", [
              _c("span", [_vm._v("Обхват бедер")]),
              _c("p", [_vm._v("Измеряется по самому широкому месту бедер ")])
            ])
          ]),
          _c("img", { attrs: { src: _vm.sizesImage, alt: "sizes-hint" } })
        ]),
        _c("h2", [_vm._v("Гид по размерам")]),
        _c("ui-tabs", {
          attrs: { items: _vm.tabs },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }